var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-allowed-page-container"},[_c('div',{staticClass:"not-allowed-page"},[_c('success-failure-display',{attrs:{"message":_vm.texts.message,"hint":_vm.texts.hint,"error":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }